import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgRainfallShower = props => _jsx("svg", _objectSpread(_objectSpread({
  width: 16,
  height: 18,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 16v2H3v-2h1Zm3 0v2H6v-2h1Zm3 0v2H9v-2h1Zm3 0v2h-1v-2h1Zm-9-3v2H3v-2h1Zm3 0v2H6v-2h1Zm3 0v2H9v-2h1Zm3 0v2h-1v-2h1Zm-9-3v2H3v-2h1Zm3 0v2H6v-2h1Zm3 0v2H9v-2h1Zm3 0v2h-1v-2h1Zm-1-6a4 4 0 0 1 4 4v1H0V8a4 4 0 0 1 4-4h8Zm0 1H4a3 3 0 0 0-2.995 2.824L1 8h14a3 3 0 0 0-2.824-2.995L12 5ZM7.5 0h1v2L9 4H7l.5-2V0Z",
    fill: props.color || "#58595B"
  })
}));
export default SvgRainfallShower;